(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const applyHeroPlaybackRate = (hero) => {
    const rate = parseFloat(hero.dataset.videoPlaybackRate);
    if (!rate) return;

    hero.querySelectorAll('video').forEach((video) => {
      video.playbackRate = rate;
      // The browser resets playbackRate whenever it loads a new source, which
      // includes the desktop/mobile swap and any theme-editor re-render.
      video.addEventListener('loadedmetadata', () => {
        video.playbackRate = rate;
      });
    });
  };

  const applyAllHeroPlaybackRates = (root) => {
    root.querySelectorAll('.hero[data-video-playback-rate]').forEach(applyHeroPlaybackRate);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applyAllHeroPlaybackRates(document), {
      once: true,
    });
  } else {
    applyAllHeroPlaybackRates(document);
  }

  // Sections re-render without a page load in the theme editor.
  document.addEventListener('shopify:section:load', (event) => {
    applyAllHeroPlaybackRates(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
